import React, { useEffect, useState, useRef } from "react";
import { GoogleMap, Marker, Polyline, InfoWindow } from "@react-google-maps/api";
import { Outlet } from "react-router-dom";
import { db } from "../../utils/firebase";
import { collection, query, onSnapshot, where } from "firebase/firestore";
import { FaSearch } from "react-icons/fa";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import car from '../../component/images/cars.png';
import bike from '../../component/images/bikes.png';
import "animate.css";
import Pending_delivery from "./components/Pending_delivery";
import CustomMarker from "./components/CustomMaker";
import All_Agent from "./components/All_Agent";

const Mapping = () => {
    const [agents, setAgents] = useState([]);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [mapCenter, setMapCenter] = useState({ lat: 6.3350262, lng: 5.6256644 });
    const [movementPaths, setMovementPaths] = useState({});

    const [pickupLocations, setPickupLocations] = useState([]);




    const [searchTerm, setSearchTerm] = useState("");


    const [modal, setModal] = useState(0)
    const mapRef = useRef(null);

    const [deliveryStats, setDeliveryStats] = useState({
        completed: 0,
        ongoing: 0,
        canceled: 0,
        pending: 0,
    });

    const containerStyle = { width: "100%", height: "500px" };
    const zoom = 15;

    const tripSummary = [
        { name: "Completed", value: deliveryStats.completed, color: "#4CAF50" },
        { name: "Ongoing", value: deliveryStats.ongoing, color: "#2196F3" },
        { name: "Canceled", value: deliveryStats.canceled, color: "#F44336" },
        { name: "Pending", value: deliveryStats.pending, color: "#FF9800" }
    ];

    useEffect(() => {
        const deliveryRequestsRef = collection(db, "delivery_requests");

        const unsubscribe = onSnapshot(deliveryRequestsRef, (snapshot) => {
            const updatedStats = { completed: 0, ongoing: 0, canceled: 0, pending: 0 };
            const newPickupLocations = [];
            const newDropOffLocations = [];

            snapshot.docs.forEach((doc) => {
                const requestData = doc.data();
                // console.log(requestData);


                if (requestData.delivery_status_is_completed) {
                    updatedStats.completed += 1;
                } else if (requestData.delivery_status_is_cancelled) {
                    updatedStats.canceled += 1;
                } else if (requestData.delivery_status_is_pending) {
                    updatedStats.pending += 1;
                } else if (requestData.delivery_status_is_started) {
                    updatedStats.ongoing += 1;
                }

                // Convert pickup location string to object
                const isNewOrder =
                    (requestData.search_timed_out === false) &&
                    (requestData.pay_timed_out === false || requestData.pay_timed_out === null) &&
                    (requestData.all_time_out === false || requestData.all_time_out === null) &&
                    (requestData.user_payment_timed_out === false || requestData.user_payment_timed_out === null) &&
                    (requestData.delivery_status_is_cancelled === false || requestData.delivery_status_is_cancelled === null) &&
                    (requestData.delivery_status_is_started === false || requestData.delivery_status_is_started === null) &&
                    (requestData.timed_out === false || requestData.timed_out === null);

                // Convert pickup location string to object if it's a new order
                if (isNewOrder && requestData.pickup_location && !requestData.delivery_status_is_accepted) {
                    const [lat, lng] = requestData.pickup_location.split(',').map(Number);
                    newPickupLocations.push({
                        id: doc.id,
                        lat,
                        lng
                    });
                }
            });

            // Convert drop-off location string to object
            // if (requestData.drop_off_location) {
            //     const [lat, lng] = requestData.drop_off_location.split(',').map(Number);
            //     newDropOffLocations.push({
            //         id: doc.id,
            //         lat,
            //         lng
            //     });
            // }

            setDeliveryStats(updatedStats);
            setPickupLocations(newPickupLocations);
        }, (err) => {
            console.error("Error fetching delivery request data: ", err);
        });

        return () => unsubscribe();
    }, []);


    useEffect(() => {
        const agentsRef = collection(db, "delivery_agents");
        const q = query(agentsRef, where("is_online", "==", true));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const updatedAgents = snapshot.docs.map((doc) => {
                const agentData = doc.data();

                return {
                    id: doc.id,
                    lat: agentData.loca_lat,
                    lng: agentData.loca_long,
                    status: agentData.status,
                    img_url: agentData.img_url,
                    vehicle_type: agentData.vehicle_type,
                    fullname: agentData.fullname,
                    phone: agentData.phone || "N/A",
                    email: agentData.email || "N/A",
                    location: agentData.location || "Unknown",
                };
            });

            updatedAgents.forEach((newAgent) => {
                setMovementPaths((prevPaths) => {
                    const existingPath = prevPaths[newAgent.id] || [];
                    const newPath = [...existingPath, { lat: newAgent.lat, lng: newAgent.lng }];

                    setTimeout(() => {
                        setMovementPaths((prev) => {
                            const updatedPaths = { ...prev };
                            updatedPaths[newAgent.id] = updatedPaths[newAgent.id]?.filter(
                                (_, index) => index !== 0
                            );
                            return updatedPaths;
                        });
                    }, 60000);

                    return { ...prevPaths, [newAgent.id]: newPath };
                });
            });

            setAgents(updatedAgents);
            setIsLoaded(true);
        }, (err) => {
            console.error("Error fetching agent data: ", err);
            setError("Failed to load agent data");
            setIsLoaded(true);
        });

        return () => unsubscribe();
    }, []);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value.toLowerCase());
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            const matchedAgent = agents.find(agent =>
                agent.fullname.toLowerCase().includes(searchTerm) ||
                agent.phone.includes(searchTerm) ||
                agent.email.toLowerCase().includes(searchTerm)
            );

            if (matchedAgent && mapRef.current) {
                mapRef.current.panTo({ lat: matchedAgent.lat, lng: matchedAgent.lng });
                mapRef.current.setZoom(150); // Adjust zoom level if needed
                setSelectedAgent(matchedAgent);
            }
        }
    };

    const handleModel = () => {
        setModal(5)
        console.log('Clicked passed to the cusomer');

    }


    const handleAgentClick = (agent) => {
        // If clicking the same agent again, close the InfoWindow
        if (selectedAgent && selectedAgent.id === agent.id) {
            setSelectedAgent(null);
        } else {
            setSelectedAgent(agent); // Otherwise, set the new agent as selected
        }

        // Optionally pan and zoom to the selected agent
        if (mapRef.current) {
            mapRef.current.panTo({ lat: agent.lat, lng: agent.lng });
            mapRef.current.setZoom(150);
        }
    };



    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="dashboard bg-white p-6">
            <div className="mb-6">
                <div className="border px-3 rounded-sm flex w-fit p-2 items-center">
                    <FaSearch />
                    <input
                        type="search"
                        placeholder="Search Agent"
                        value={searchTerm}
                        onChange={handleSearch}
                        onKeyDown={handleKeyDown} // Listen for Enter key press
                        className="placeholder:text-[12px] outline-none mapping-placeo ml-4 border-none"
                    />

                </div>
            </div>

            <div className="flex flex-col gap-8 h-[80vh]">
                <div className="w-full lg:w-[100%] h-full rounded-xl">
                    <GoogleMap
                        mapContainerStyle={containerStyle}
                        zoom={zoom}
                        center={mapCenter}
                        onLoad={(map) => mapRef.current = map}
                        options={{
                            mapTypeControl: false,
                            streetViewControl: false,
                            fullscreenControl: false,
                        }}
                    >
                        <div className="cursor-pointer" >
                            {pickupLocations.map((pickup) => {
                                console.log('onClick function:', handleModel);  
                                return (
                                    <CustomMarker
                                        key={pickup.id}
                                        map={mapRef.current}
                                        position={pickup}
                                        isNewDelivery={true}
                                        onClick={handleModel} 
                                    />
                                );
                            })}
                        </div>

                        {isLoaded && agents.length > 0 ? (
                            agents.map((agent) => (
                                <React.Fragment key={agent.id}>
                                    <Marker
                                        position={{ lat: agent.lat, lng: agent.lng }}
                                        icon={{
                                            url: agent.vehicle_type === "bike" ? bike : car,
                                            scaledSize: new window.google.maps.Size(30, 30),
                                        }}
                                        onClick={() => handleAgentClick(agent)}
                                    />

                                    {selectedAgent && selectedAgent.id === agent.id && (
                                        <InfoWindow
                                            position={{ lat: agent.lat, lng: agent.lng }}
                                            onCloseClick={() => setSelectedAgent(null)}  // Close the InfoWindow when clicking the close button
                                            options={{ animation: window.google.maps.Animation.DROP }}
                                        >
                                            <div className="animate__animated animate__fadeIn">
                                                <div className="flex items-center gap-4">
                                                    <img
                                                        src={agent.img_url}
                                                        alt={agent.fullname}
                                                        className="w-12 h-12 rounded-full object-cover"
                                                    />
                                                    <div>
                                                        <h3 className="font-bold text-lg">{agent.fullname}</h3>
                                                        <p>🚗 Vehicle: {agent.vehicle_type.toUpperCase()}</p>
                                                        <p>📍 Location: {agent.location}</p>
                                                        <p className={`font-bold ${agent.status === "active" ? "text-green-500" : "text-red-500"}`}>
                                                            🔵 Status: {agent.status}
                                                        </p>
                                                        <p onClick={() => {
                                                            setSelectedAgent(agent);  // Ensure selected agent is set
                                                            setModal(1);  // Open the modal
                                                        }} className="cursor-pointer">Assign</p>                                                    </div>
                                                </div>


                                                {
                                                    (modal === 1) &&
                                                    <Pending_delivery delivery_agent={selectedAgent} onClose={() => setModal(0)} />
                                                }

                                                {modal === 5 && <All_Agent agents={agents} onClose={() => setModal(0)} />}

                                            </div>
                                        </InfoWindow>
                                    )}

                                    {movementPaths[agent.id] && (
                                        <Polyline
                                            path={movementPaths[agent.id]}
                                            options={{
                                                strokeColor: "#",
                                                strokeOpacity: 0.1,
                                                strokeWeight: 4,
                                            }}
                                        />
                                    )}
                                </React.Fragment>
                            ))
                        ) : (
                            <div>Loading agents...</div>
                        )}

                    </GoogleMap>
                    <Outlet />
                </div>

                <div className=" md:w-[] flex items-end self-end flex-col gap-6">
                    <div className="w-full h-fit mt-10 mb-20 flex flex-col items-center shadow-2xl rounded-md border border-gray-300 p-3">
                        <h3 className="text-lg font-bold mb-8">Order Chart Summary</h3>
                        <PieChart width={150} height={150}>
                            <Pie
                                data={tripSummary}
                                dataKey="value"
                                cx="30%"
                                cy="30%"
                                outerRadius={50}
                                fill="#8884d8"
                                label
                            >
                                {tripSummary.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                    </div>
                </div>
            </div>



        </div>
    );
};

export default Mapping;
